var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import { components, config } from "./relation-query-base/";
var collectionManageModule = namespace("collection-manage");
var RelationQueryBase = /** @class */ (function (_super) {
    __extends(RelationQueryBase, _super);
    function RelationQueryBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // private tabsConfig:any[] = [];
        _this.tabsConfig = config;
        _this.currentComponent = "PhoneQuery";
        _this.currentTab = _this.$refs["phone-query"];
        return _this;
    }
    Object.defineProperty(RelationQueryBase.prototype, "personalId", {
        get: function () {
            return this.currentCase.personalId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RelationQueryBase.prototype, "idCardNo", {
        get: function () {
            return this.currentCase.certificateNo;
        },
        enumerable: false,
        configurable: true
    });
    RelationQueryBase.prototype.onRecordCountChange = function () {
        this.currentComponent = "PhoneQuery";
    };
    RelationQueryBase.prototype.mounted = function () {
        // this.tabsConfig = config.filter(item => this.controlResource.includes(item.auth.toString()))
    };
    __decorate([
        collectionManageModule.State
    ], RelationQueryBase.prototype, "caseId", void 0);
    __decorate([
        collectionManageModule.Getter
    ], RelationQueryBase.prototype, "personalInfo", void 0);
    __decorate([
        collectionManageModule.State
    ], RelationQueryBase.prototype, "recordCount", void 0);
    __decorate([
        collectionManageModule.State
    ], RelationQueryBase.prototype, "currentCase", void 0);
    __decorate([
        State
    ], RelationQueryBase.prototype, "controlResource", void 0);
    __decorate([
        Prop()
    ], RelationQueryBase.prototype, "isHistory", void 0);
    __decorate([
        Watch("recordCount")
    ], RelationQueryBase.prototype, "onRecordCountChange", null);
    RelationQueryBase = __decorate([
        Component({
            components: components
        })
    ], RelationQueryBase);
    return RelationQueryBase;
}(Vue));
export default RelationQueryBase;
